<script lang="ts" setup>
import type { Charecter } from '@/stores/store'

import dayjs from 'dayjs'
import { computed, onMounted } from 'vue'

import { useCharecterStore } from '@/stores/store'

const characterStore = useCharecterStore()
function handleEdit(row: Charecter) {
  // 跳转路由
  characterStore.setCurrentCharecter(row.id)
  console.log(row)
}

const tableData = computed(() => characterStore.charecterList.map((character) => {
  // 时间格式化成中文的
  console.log(dayjs(character.created_at).format('YYYY-MM-DD HH:mm:ss'))
  return {
    ...character,
    created_at: dayjs(character.created_at).format('YYYY-MM-DD HH:mm:ss'),
    updated_at: dayjs(character.updated_at).format('YYYY-MM-DD HH:mm:ss'),
  }
}))
onMounted(() => {
  console.log('onMounted')
  characterStore.fetchCharecters()
})
</script>

<template>
  <el-button type="primary" @click="characterStore.createCharecter">
    新增角色模版
  </el-button>
  <el-button type="primary" @click="$router.push('/createVoice')">
    训练火山引擎音色
  </el-button>
  <el-table :data="tableData">
    <el-table-column prop="id" label="id" width="120" />
    <el-table-column prop="name" label="姓名" width="120" />
    <el-table-column label="上线状态" width="120">
      <template #default="{ row }">
        <el-tag v-if="row.status === 'online'" effect="dark" type="success">
          online
        </el-tag>
        <el-tag v-else effect="dark" type="info">
          offline
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column prop="description" label="描述" width="300" />
    <el-table-column prop="created_at" label="创建时间" width="120" />
    <el-table-column prop="updated_at" label="更新时间" width="120" />
    <el-table-column fixed="right" label="操作" min-width="120">
      <template #default="{ row }">
        <el-button size="small" type="primary" @click="handleEdit(row)">
          编辑
        </el-button>
        <el-button size="small" type="danger">
          删除
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>
